<template>
  <el-dialog
    :title="`绑定分类`"
    :visible.sync="modalShow"
    width="700px"
    append-to-body
  >
    <el-form :model="searchForm" ref="searchForm" size="small" inline>
      <el-form-item label="分类导航名称" prop="className">
        <el-input
          v-model.trim="searchForm.className"
          placeholder="分类导航名称"
        />
      </el-form-item>
      <el-form-item label=" " label-width="100px">
        <el-button type="primary" @click="search('searchForm')">查询</el-button>
        <el-button @click="reset('searchForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <br />
    <el-table
      border
      stripe
      v-loading="loading"
      :data="tableData"
      ref="table"
      style="width: 100%"
      class="eltable_box"
      @select="select"
      @select-all="selectAll"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        :selectable="checkAble"
        minWidth="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="className"
        label="分类导航名称"
        minWidth="250"
        align="center"
      ></el-table-column>
    </el-table>
    <br />
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="pageSizes"
      layout="total, sizes, prev, pager, next"
      :total="total"
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="modalShow = false">取 消</el-button>
      <el-button type="primary" @click="submit()">绑 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import tableMoudel from "@/libs/mixin/table";
import { Admin, fenleiApi } from "../api";
export default {
  mixins: [tableMoudel],
  data() {
    return {
      modalShow: false,
      searchForm: {
        className: "",
      },
      selectIds: [],
      selectIdsNames: [],
      id: null,
    };
  },
  watch: {
    modalShow: {
      handler(value) {
        if (!value) {
          this.$refs["searchForm"].resetFields();
        }
      },
    },
  },
  methods: {
    init(id) {
      this.modalShow = true;
      this.id = id;
      this.getData();
    },
    checkAble(row) {
      return row.checkFlag != 1;
    },
    select(selection, row) {
      if (selection.length > 1) {
        let del_row = selection.shift();
        this.$refs.table.toggleRowSelection(del_row, false);
      }
    },
    selectAll(selection) {
      if (selection.length > 1) {
        selection.length = 1;
      }
    },
    handleSelectionChange(val) {
      this.selectIds = val.map((item) => item.id);
      this.selectIdsNames = val.map((item) => item.className);
    },
    async getData() {
      const params = { ...this.pageInfo, ...this.searchForm };
      const res = await fenleiApi.getListPage(params);
      if (res.code !== 0) return;
      const { records } = res.data;
      this.tableData = records;
      this.total = Number(res.data.total);
    },
    async submit() {
      if (this.selectIds.length == 0) {
        this.$message.warning("请选择要绑定的数据!");
        return false;
      }
      const params = {
        classId: this.selectIds.join(","),
        className: this.selectIdsNames.join(","),
        id: this.id,
      };
      const res = await Admin.updateActivitySpSku(params);
      if (res.code !== 0) return;
      this.$message.success("操作成功!");
      this.$bus.$emit("update", true);
      this.modalShow = false;
    },
  },
};
</script>

<style lang="scss">
.eltable_box {
  .has-gutter .el-table-column--selection .el-checkbox{
    display: none;
  }
}
</style>